import React from 'react';
import { curry } from 'lodash/fp';
import { Typography } from '@mui/material';
import clsx from 'clsx';

const renderTypography = curry((
  variant: Parameters<typeof Typography>[0]['variant'] | '',
  _: any,
  children: any,
) => {
  const isParagraph = variant === 'body2';

  return (
    <Typography
      variant={variant || undefined}
      gutterBottom={false}
      className={clsx(isParagraph && 'mb-0')}
    >
      {children}
    </Typography>
  );
});

export default renderTypography;
